import { OrgChart } from "@/components/organization/OrgChart";
import { PageHeader } from "@/components/shared/page-header";

export function OrgChartPage() {
  return (
    <div className="flex h-[calc(100vh-180px)] min-h-[480px] flex-col gap-6">
      <PageHeader
        title="Org Chart"
        description="Who reports to whom. Your chain of command starts expanded — open any branch to explore the rest of the company."
      />
      <div className="min-h-0 flex-1">
        <OrgChart />
      </div>
    </div>
  );
}
